import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import { server } from '../../server'; 
import MyEventCard from './MyEventCard';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const MyEvents = ({ title = 'Events' }) => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const railRef = useRef(null);
    const currentProfileType = useSelector((state) => state.user.currentProfile);

    useEffect(() => {
        fetchMyEvents();
    }, [currentProfileType]);

    const fetchMyEvents = async () => {
        try {
            const response = await axios.get(`${server}/event/events/my`, {
                withCredentials: true,
                params: {
                    profile: currentProfileType,
                },
            });
            setEvents(response.data);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch events');
            setLoading(false);
            console.error(err);
        }
    };

    const handleCancelRSVP = async (eventId) => {
        try {
            await axios.delete(`${server}/event/rsvp/${eventId}`, {
                withCredentials: true,
                data: {
                    currentProfile: currentProfileType,
                },
            });
            
            // Remove the event from the list of displayed events
            const updatedEvents = events.filter(event => event._id !== eventId);
            setEvents(updatedEvents);
        } catch (error) {
            console.error('Failed to cancel RSVP:', error);
            alert('Failed to cancel RSVP: ' + (error.response?.data?.message || 'Error occurred'));
        }
    };

    const scrollMyEventsRail = (direction) => {
        if (!railRef.current) {
            return;
        }

        const scrollAmount = Math.max(railRef.current.clientWidth * 0.82, 220);
        railRef.current.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    };

    if (loading) return <p>Loading...</p>;
    
    const hasMultipleEvents = events.length > 1;

    return (
        <div className="my-events-container">
            <div className="events-page-section-heading-row my-events-heading-row">
                <h3 className="events-page-section-title my-events-title">{title}</h3>
            </div>
            {events.length > 0 ? (
                <div className={`my-events-rail-shell${hasMultipleEvents ? '' : ' my-events-rail-shell--single'}`}>
                    {hasMultipleEvents && (
                        <button
                            type="button"
                            className="events-page-gallery-arrow events-page-gallery-arrow--prev my-events-rail-arrow my-events-rail-arrow--prev"
                            aria-label="Scroll your events left"
                            onClick={() => scrollMyEventsRail(-1)}
                        >
                            <FaChevronLeft aria-hidden="true" />
                        </button>
                    )}
                    <div className="my-events-list" ref={railRef} tabIndex="0">
                        {events.map(event => (
                            <MyEventCard key={event._id} event={event} onCancelRSVP={handleCancelRSVP} />
                        ))}
                    </div>
                    {hasMultipleEvents && (
                        <button
                            type="button"
                            className="events-page-gallery-arrow events-page-gallery-arrow--next my-events-rail-arrow my-events-rail-arrow--next"
                            aria-label="Scroll your events right"
                            onClick={() => scrollMyEventsRail(1)}
                        >
                            <FaChevronRight aria-hidden="true" />
                        </button>
                    )}
                </div>
            ) : (
                <div>
                    <Link to="/events">
                        <button className="find-events-button">Find Events</button>
                    </Link>
                </div>
            )}
        </div>
    );
};

export default MyEvents;


